<div #coverPageWrapper>
  <div #coverPage class="coverPage resource" style="margin-left: auto; margin-right: auto; margin-top: 20px;">
    <div #coverClippingRect class="clippingRect">
      <img #image style="position: absolute; display: block;" src="">
      <p *ngIf="hasResource && !coverImageLoaded" style="width: 100%; text-align: center; height: 500px; line-height: 500px; font-weight: bold; color: black; font-size: xxx-large; position: relative; z-index: 0;" i18n="@@Loading Image">Loading Image</p>
      <p *ngIf="!hasResource" style="width: 100%; text-align: center; height: 500px; line-height: 500px; font-weight: bold; color: black; font-size: xx-large; position: relative; z-index: 0;" i18n="@@No PDF Uploaded Yet">No PDF Uploaded Yet</p>
    </div>
    <div #coverBounds style="position: absolute;">
      <div class="boundsMarker" #backCoverBounds style="position: absolute; top: 0px; left: 0px;"></div>
      <div class="boundsMarker" #spineCoverBounds style="position: relative; top: 0px; margin-left: auto; margin-right: auto;"></div>
      <div class="boundsMarker" #frontCoverBounds style="position: absolute; top: 0px; right: 0px;"></div>
    </div>
    <div #coverLines style="position: absolute;">
      <div class="sharpMarker" #backCoverLine style="position: absolute; top: 0px; left: 0px;"></div>
      <div class="sharpMarker" #spineCoverLine style="position: relative; top: 0px; margin-left: auto; margin-right: auto;"></div>
      <div class="sharpMarker" #frontCoverLine style="position: absolute; top: 0px; right: 0px;"></div>
    </div>
  </div>

  <!-- Floating toolbar for cover -->
  <div class="cover-toolbar" *ngIf="draft"
       [ngClass]="'cover-toolbar-' + currentToolbarPosition"
       #coverToolbar>

    <div class="cover-drag-handle"
         (mousedown)="onDragStart($event)"
         (touchstart)="onDragStart($event)"
         i18n-title="@@Drag to Move" title="Drag to Move">
      <mat-icon>drag_indicator</mat-icon>
    </div>

    <button class="cover-expand-collapse-btn" (click)="toggleToolbarExpanded()"
            i18n-title="@@Expand/Collapse Controls" title="Expand/Collapse Controls">
      <mat-icon *ngIf="!toolbarExpanded">unfold_more</mat-icon>
      <mat-icon *ngIf="toolbarExpanded">unfold_less</mat-icon>
    </button>

    <!-- Shift d-pad and scale -->
    <div class="cover-toolbar-row">
      <div class="cover-shift-group">
        <label i18n="@@Cover Shift">Cover Shift</label>
        <div class="cover-dpad-and-value">
          <div class="cover-dpad">
            <button class="cover-dpad-btn cover-dpad-up"
                    (click)="changeShift(0, 9)"
                    i18n-title="@@Up" title="Up">▲</button>
            <div class="cover-dpad-middle-row">
              <button class="cover-dpad-btn cover-dpad-left"
                      (click)="changeShift(-9, 0)"
                      i18n-title="@@Left" title="Left">◀</button>
              <span class="cover-dpad-center"></span>
              <button class="cover-dpad-btn cover-dpad-right"
                      (click)="changeShift(9, 0)"
                      i18n-title="@@Right" title="Right">▶</button>
            </div>
            <button class="cover-dpad-btn cover-dpad-down"
                    (click)="changeShift(0, -9)"
                    i18n-title="@@Down" title="Down">▼</button>
          </div>
          <div class="cover-shift-values">
            <div class="cover-shift-value-row">
              <span class="cover-shift-label" i18n="@@V">V</span>
              <input type="number" [ngModel]="roundHundredths(verticalShift / unitMultiplier)" (change)="onShiftInput('vertical', $event.target.value)">
            </div>
            <div class="cover-shift-value-row">
              <span class="cover-shift-label" i18n="@@H">H</span>
              <input type="number" [ngModel]="roundHundredths(horizontalShift / unitMultiplier)" (change)="onShiftInput('horizontal', $event.target.value)">
            </div>
          </div>
        </div>
      </div>

      <div class="cover-scale-group">
        <label i18n="@@Scale">Scale</label>
        <input type="number" class="cover-scale-input"
               [ngModel]="scale" (change)="onScaleInput($event.target.value)"
               min="0.1" max="3.0" step="0.05">
      </div>
    </div>

    <!-- Trim Size and Units in horizontal row - Hidden in compact mode -->
    <div class="cover-trim-and-units-row" *ngIf="toolbarExpanded">
      <div class="cover-trim-size-section">
        <mat-form-field class="cover-trim-size-select" appearance="outline">
          <mat-label i18n="@@Trim Size">Trim Size</mat-label>
          <mat-select [value]="selectedTrimSize" (selectionChange)="onTrimSizePresetChange($event.value)">
            <mat-option *ngFor="let preset of trimSizePresets" [value]="preset.label" [class.promoted]="preset.isPromoted">
              {{getTrimSizeLabel(preset)}}
            </mat-option>
            <mat-option value="CUSTOM">
              <span *ngIf="selectedTrimSize === 'CUSTOM'">
                <span i18n="@@Custom">Custom</span> ({{getCustomTrimSizeLabel()}})
              </span>
              <span *ngIf="selectedTrimSize !== 'CUSTOM'" i18n="@@Custom">Custom</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="cover-unit-selector">
        <label i18n="@@Units">Units:</label>
        <button [class.active]="unit === 'in'" (click)="changeUnits('in')" i18n="@@Inches">in</button>
        <button [class.active]="unit === 'mm'" (click)="changeUnits('mm')" i18n="@@Millimeters">mm</button>
      </div>
    </div>

    <!-- Custom trim inputs (shown below trim size when editing) -->
    <div *ngIf="editingCustomTrim && toolbarExpanded" class="cover-custom-trim-inputs">
      <mat-form-field class="cover-trim-size-custom-input" appearance="outline">
        <mat-label i18n="@@Width">W</mat-label>
        <input matInput type="number"
               [ngModel]="getCustomWidthInCurrentUnits()"
               (ngModelChange)="setCustomWidthFromCurrentUnits($event)"
               [ngModelOptions]="{standalone: true}"
               [min]="unit === 'mm' ? 50 : 2"
               [max]="unit === 'mm' ? 500 : 20"
               [step]="unit === 'mm' ? 1 : 0.25">
        <span matSuffix>{{unit === 'mm' ? 'mm' : '"'}}</span>
      </mat-form-field>
      <span class="cover-trim-size-x">×</span>
      <mat-form-field class="cover-trim-size-custom-input" appearance="outline">
        <mat-label i18n="@@Height">H</mat-label>
        <input matInput type="number"
               [ngModel]="getCustomHeightInCurrentUnits()"
               (ngModelChange)="setCustomHeightFromCurrentUnits($event)"
               [ngModelOptions]="{standalone: true}"
               [min]="unit === 'mm' ? 50 : 2"
               [max]="unit === 'mm' ? 500 : 20"
               [step]="unit === 'mm' ? 1 : 0.25">
        <span matSuffix>{{unit === 'mm' ? 'mm' : '"'}}</span>
      </mat-form-field>
      <button mat-icon-button
              (click)="saveCustomTrim()"
              [disabled]="!customTrimChanged"
              i18n-title="@@Save" title="Save">
        <mat-icon>check</mat-icon>
      </button>
      <button mat-icon-button
              (click)="cancelCustomTrim()"
              i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel" title="Cancel">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Units selector -->
    <div class="cover-unit-selector" *ngIf="false">
      <!-- Hidden - now in trim-and-units-row -->
    </div>


    <!-- Zoom -->
    <div class="cover-zoom-area">
      <label i18n="@@Zoom">Zoom</label>
      <input type="range" min="0.05" max="2.0" step="0.025"
             [value]="zoomLevel" (input)="onZoomChange($event)">
      <span class="cover-zoom-indicator">{{ localizeNumber((zoomLevel * 400).toFixed(0)) }}%</span>
    </div>
  </div>
</div>
